import RMultilingual from './Multilingual';

export const linkPrivacyList = ['PUBLIC', 'UNLISTED', 'KEY_REQUIRED'];

export const registrationColumnTypes = ['TEXT', 'DATE', 'IMAGE', 'PDF'];

export const defaultTeamColumns = [
  { name: 'CITY', hint: 'CITY', type: 'TEXT', is_required: true },
  { name: 'NAME', hint: 'NAME', type: 'TEXT', is_required: true },
  { name: 'ICON', hint: 'ICON', type: 'IMAGE', is_required: true },
  { name: 'CONTACT_PERSON', hint: 'CONTACT_PERSON', type: 'TEXT', is_required: true },
  { name: 'CONTACT_PHONE', hint: 'CONTACT_PHONE', type: 'TEXT', is_required: true },
];

export const defaultStaffColumns = [
  { name: 'NAME', hint: 'NAME', type: 'TEXT', is_required: true },
  { name: 'AVATAR', hint: 'AVATAR', type: 'IMAGE', is_required: true },
  { name: 'NUMBER', hint: 'NUMBER', type: 'TEXT', is_required: false },
  { name: 'LICENSE', hint: 'LICENSE', type: 'PDF', is_required: false },
];

export const defaultPlayerColumns = [
  { name: 'NAME', hint: 'NAME', type: 'TEXT', is_required: true },
  { name: 'NUMBER', hint: 'NUMBER', type: 'TEXT', is_required: true },
  { name: 'AVATAR', hint: 'AVATAR', type: 'IMAGE', is_required: true },
  { name: 'BIRTHDAY', hint: 'BIRTHDAY', type: 'DATE', is_required: true },
  { name: 'FIRST_POSITION', hint: 'FIRST_POSITION', type: 'TEXT', is_required: true },
  { name: 'SECOND_POSITION', hint: 'SECOND_POSITION', type: 'TEXT', is_required: true },
  { name: 'P_HAND', hint: 'P_HAND', type: 'TEXT', is_required: true },
  { name: 'B_HAND', hint: 'B_HAND', type: 'TEXT', is_required: true },
];

export const getInitRegistryInfo = () => {
  return {
    uniqid: '',
    description: '',
    content: '', // 報名規章的 html 內容，先不使用
    is_public: true,
    entry_key: '',
    regulation_file_path: '',
    regulation_file_url: '',
    team_limit: 20,
    team_description: '',
    player_limit: 20,
    player_description: '',
    avatar_ratio_x: 3.5,
    avatar_ratio_y: 4.5,
    team_columns: [],
    staff_titles: [
      {
        title: RMultilingual(`DEFAULT_STAFF.COACH`),
        is_required: true,
        columns: defaultStaffColumns.map((column) => ({
          name: RMultilingual(`DEFAULT_COLUMN.STAFF.${column.name}.NAME`),
          hint: RMultilingual(`DEFAULT_COLUMN.STAFF.${column.hint}.HINT`),
          type: column.type,
          is_required: column.is_required,
        })),
      },
    ],
    player_columns: [],
    attachments: [],
    fee: 0.0,
    fee_currency: 'NTD',
    fee_description: '',
    payment_method: [],
    allow_online_payment: false,
    start_at: '',
    end_at: '',
  };
};
